export function computeEr(impressions: number | null, interactions: number | null): number | null {
  if (!impressions || !interactions) return null;
  if (impressions === 0) return null;
  return (interactions / impressions) * 100;
}

export function computeErByReach(reach: number | null, interactions: number | null): number | null {
  if (!reach || !interactions) return null;
  if (reach === 0) return null;
  return (interactions / reach) * 100;
}
